import React, { useEffect, useState, useRef } from 'react';
import * as examinationAction from "../../redux/store-sarang/examination-report/examination-report-management.store";
import DepartmentRankCupWidget from '../examination-dashboard/components/department-rank-cup-widget';
;export default function ExamDepartmentReport() {
    //const userInfo = getUserInfo();
    const [week, setWeek] = useState();
    const [month, setMonth] = useState();
    const limit = 10;
    useEffect(() => {
        GetCurrentWeek();
    }, [])

    const GetCurrentWeek = async () => {
        try {
            const res = await examinationAction.GetCurrentWeek();

            if (res && res.content) {
                setWeek(res.content);
                if (res.content.month==9)
                    setMonth({ month: 8, year: res.content.year, week: undefined });
                else
                    setMonth({ ...res.content, week: undefined });
            }
        } catch (err) {
            ;
            
        } finally {
            ;
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                    <DepartmentRankCupWidget
                        week={week}
                        limit={limit}
                    />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                    <DepartmentRankCupWidget
                        week={month}
                        limit={1000}
                    />
                </div>
            </div>
           
        </>
    )
}